import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import EventsPage from "@/pages/EventsPage";

export const Route = createFileRoute("/_app/events")({
  head: () => ({ meta: [
    { title: "Événements — Thiia" },
    { name: "description", content: "Vos événements et participations dans Thiia." },
    { property: "og:title", content: "Événements — Thiia" },
    { property: "og:description", content: "Vos événements et participations dans Thiia." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="events">
      <EventsPage />
    </ModuleGuard>
  );
}
